import React, { Component } from "react";
import {
  Table,
  Column,
  ColumnGroup,
  Cell
} from "fixed-data-table-2";
import Loader from "react-loader-advanced";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import _ from "lodash";
import find from "lodash/find";
import toFinite from "lodash/toFinite";
import union from "lodash/union";
import without from "lodash/without";

import { closeHistory } from "../../actions/domActions";
import { onAuthorization } from "../../actions/userActions";
import BaseModal from "../Modals/BaseModal";
import DropDown from "./DropDown";
import ClickTextField from "./ClickTextField";
import { alert } from "../Modals/ConfirmModal";
import sentry from "../../utils/sentry";
import Container from "../container";

require("./fixed-data-table.css");
require("./AdminScreen.scss");

function mapStateToProps(state, ownProps) {
  let categories = (state.categories.categoriesList)
    ? _.sortBy(state.categories.categoriesList, "name")
    : [];

  return {
    api: state.api,
    user: state.user,
    categories,
    userState: state.userState,
    roles: state.roles
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    closeHistory: () => dispatch(closeHistory()),
    onRefresh: () => dispatch(onAuthorization()),
    onGetCategories: (categories) => {
      dispatch({ type: "FETCH_CATEGORIES_FULFILLED", payload: categories });
      dispatch({ type: "SET_CATEGORY", payload: null });
    },
    onGetRoles: (roles) => dispatch({ type: "SET_ROLES", roles }),
  };
}

class Admin extends Component{
  constructor (props) {
    super(props);

    this.initialLoad = true;

    this.state = {
      categories: Array.isArray(props.categories) ? props.categories : [],
      categoriesDelete: [],
      loading: false,
      modalsOpen: {},
      roleSettings: []
    };

    this.fields = [
      { id: "account", label: "Account" },
      //{ id: "competitiveReplacement", label: "Comp. Repl.", title: "Competitive Replacement" },
      { id: "onsite", label: "On Site" },
      { id: "onsiteDetail", label: "With Customer?", title: "How the employee was with a customer. Hidden for CAE regardless of this setting", },
      { id: "location", label: "Location" },
      { id: "productGroup", label: "Product Group" },
      { id: "productLine", label: "Product Line" },
      { id: "distributor", label: "Distributor" },
      { id: "opportunity", label: "Opportunity" },
      { id: "serviceRequest", label: "Service Request" },
      { id: "interlock", label: "Interlock" },
    ];
  }

  loadRoles() {
    if (this.initialLoad && this.props.roles.length > 0) {
      const modalsOpen = {};

      this.initialLoad = false;

      for (const role of this.props.roles) {
        modalsOpen[role.id] = false;
      }

      const roleSettings = normalizeRoles(this.props.roles);

      this.setState({ loading: false, modalsOpen, roleSettings });
    }
  }

  componentDidMount() {
    this.props.closeHistory();

    this.loadRoles();
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.categories, this.props.categories)) {
      this.setState({
        categories: this.props.categories
      });
    }

    this.loadRoles();
  }

  getCategories() {
    setTimeout(() => {
      this.props.api.getCategories(this.props.user.timeTrackingRole)
        .then((categories) => {
          this.props.onGetCategories(categories);
          this.setState({ loading: false, categories });
        })
        .catch((error) => {
          sentry.logException(error);
          this.setState({ loading: false });
        });
    }, 1000);
  }

  saveSettings() {
    const categories = this.state.categories;

    const categoriesChanged = _.filter(categories, (x) => Boolean(x.changed));
    const categoriesNew = _.filter(categories, (x) => Boolean(x.new));
    const categoriesDeleted = this.state.categoriesDelete.slice();

    let promises = [];

    const haveCategoriesChanged = categoriesChanged.length > 0 || categoriesNew.length > 0 || categoriesDeleted.length > 0;

    if (haveCategoriesChanged) {
      this.setState({ loading: true, categoriesDelete: [] });
    }

    promises = promises.concat(
      _.map(categoriesChanged, (x) => this.props.api.editCategories(
        x.id,
        x.name,
        x.desc,
        x.roles,
        x.fields
      ))
    );

    promises = promises.concat(
      _.map(categoriesNew, (x) => this.props.api.postCategories(
        x.name,
        x.desc,
        x.roles,
        x.fields
      ))
    );

    promises = promises.concat(
      _.map(categoriesDeleted, (x) => this.props.api.deleteCategories(
        x.id
      ))
    );

    Promise.all(promises)
      .then(() => this.getCategories())
      .catch((error) => {
        sentry.logException(error);
        this.getCategories();
        alert("An unexpected error occurred. Please try again.");
      });
  }

  addNewCategory() {
    const categories = this.state.categories.slice();

    categories.push({
      new: true,
      name: "Category Name",
      desc: "Category Description",
      roles: ["Administrator"],
      fields: _.map(this.fields, (x) => ({ id: x.id, required: "optional" }))
    });

    this.setState({ categories });
  }

  _onChangeRole(fieldName, rowIndex) {
    const category = this.state.categories[rowIndex];
    const categories = this.state.categories.slice();

    if (category.roles.includes(fieldName)) {
      category.roles = without(category.roles, fieldName);
    } else {
      category.roles = union(category.roles, [fieldName]);
    }

    if (!category.new) {
      category.changed = true;
    }

    categories[rowIndex] = category;

    this.setState({ categories });
  }

  _onChangeVisibility(fieldName, rowIndex, value) {
    let category = this.state.categories[rowIndex];
    let categories = this.state.categories.slice();
    let i = 0;

    for (i = 0; i < category.fields.length; ++i) {
      if (category.fields[i].id === fieldName) {
        category.fields[i].required = value;
        break;
      }
    }

    // didn't find the field? we'll add it.
    if (i === category.fields.length) {
      category.fields.push({
        id: fieldName,
        required: value
      });
    }

    if (!category.new) {
      category.changed = true;
    }

    categories[rowIndex] = category;

    this.setState({ categories });
  }

  _onDeleteCategory(rowIndex) {
    const categories = this.state.categories.slice();
    const categoryToDelete = categories[rowIndex];
    const categoriesDelete = this.state.categoriesDelete.slice();

    categories.splice(rowIndex, 1);

    if (!categoryToDelete.new) {
      categoriesDelete.push(categoryToDelete);
    }

    this.setState({ categories, categoriesDelete }, () => {
      setTimeout(() => {
        this.forceUpdate();
      }, 100);
    });
  }

  _onChangeValue(fieldName, newValue, rowIndex) {
    let category = this.state.categories[rowIndex];
    let categories = this.state.categories.slice();

    categories[rowIndex][fieldName] = newValue;
    if (!category.new) {
      category.changed = true;
    }

    this.setState({ categories });
  }

  _renderRole(category, fieldName, rowIndex, props = {}) {
    if (category) {
      let checked = category.roles.indexOf(fieldName) > -1;
      return(
        <Cell {...props}>
          <input
            type="checkbox"
            checked={checked}
            onChange={() => this._onChangeRole(fieldName, rowIndex)}
          />
        </Cell>
      );
    } else return null;
  }

  _renderTextField(category, fieldName, rowIndex, type, props = {}) {
    if (!category) {
      return null;
    }

    let value = category[fieldName];
    let AfterField = null;

    if (fieldName === "name") {
      AfterField = (
        <div
          className="delete-category"
          onClick={() => { this._onDeleteCategory(rowIndex) }}
        >
          <b></b>
        </div>
      );
    }

    return (
      <Cell {...props}>
        <ClickTextField
          value={value}
          type={type}
          onChange={(newValue) => this._onChangeValue(
            fieldName,
            newValue,
            rowIndex
          )}
        >
          {AfterField}
        </ClickTextField>
      </Cell>
    );
  }

  _renderVisibilityField(category, fieldName, rowIndex, props = {}) {
    if (!category) {
      return null;
    }

    const optionValues = ["optional", "hidden", "required"];

    let fieldType = _.first(optionValues);

    for (let i = 0; i < category.fields.length; ++i) {
      if (category.fields[i].id === fieldName) {
        fieldType = category.fields[i].required;
      }
    }

    const notRequired = _.filter(optionValues, (o) => (o !== fieldType));

    const options = _.map(notRequired, (option, i) => {
      return (
        <li key={`${option}-${rowIndex} -${i}`}>
          <a onClick={() => this._onChangeVisibility(
            fieldName,
            rowIndex,
            option
          )}>{option}</a>
        </li>
      );
    });

    return (
      <Cell {...props}>
        <div id={`select-${fieldName}${rowIndex}`} className="">
          <DropDown label={fieldType}>{options}</DropDown>
        </div>
      </Cell>
    );
  }

  onChangeHours(i, n) {
    const value = parseFloat(n);
    const isValid = !isNaN(value) && isFinite(value);

    if (!isValid && n.trim() !== '') {
      return;
    }

    if (value > 24) {
      return;
    }

    //If is float
    if (value % 1 !== 0) {
      n = (Math.round(value * 2) / 2).toFixed(1).toString();
    }

    const roleSettings = this.state.roleSettings.slice();
    roleSettings[i].defaultWorkingHours = n;
    this.setState({ roleSettings });
  }

  onChangeDays(i, n) {
    const isValid = !isNaN(value) && isFinite(value);
    let value = parseFloat(n);

    if (value < 0) {
      return;
    }

    if (!isValid && n.trim() !== '') {
      return;
    }

    //If is float
    if (value % 1 !== 0) {
      value = Math.floor(value);
    }

    const roleSettings = this.state.roleSettings.slice();
    roleSettings[i].notificationDelay = n;
    this.setState({ roleSettings });
  }

  closeRoleModal(role) {
    this.setState({
      modalsOpen: { ...this.state.modalsOpen, [role.id]: false },
      roleSettings: _.map(this.props.roles, (x) => ({
        id: x.id,
        notificationDelay: x.notificationDelay,
        defaultWorkingHours: x.defaultWorkingHours
      }))
    });
  }

  async saveRoles() {
    const newState = { modalsOpen: {} };

    for (const roleId of this.state.modalsOpen) {
      newState.modalsOpen[roleId] = false;
    }

    newState.modalsOpen = modalsOpen;

    for (const roleUnsaved of this.state.roleSettings) {
      const id = { roleUnsaved };
      const roleSaved = find(this.props.roles, { id });

      if (!roleSaved) {
        continue;
      }

      const needUpdate = roleSaved.defaultWorkingHours !== roleUnsaved.defaultWorkingHours || roleSaved.notificationDelay !== roleUnsaved.notificationDelay;

      if (!needUpdate) {
        continue;
      }

      this.setState({ ...newState, loading: true });

      try {
        const role = await this.props.api.editRoles(
          id,
          Math.floor(roleUnsaved.notificationDelay),
          toFinite(roleUnsaved.defaultWorkingHours)
        );

        newState.roleSettings = updateRoles(this.props.roles, role);

        this.props.onGetRoles(roles);
      } catch (err) {
        sentry.logException(error);

        newState.roleSettings = normalizeRoles(this.props.roles);
      } finally {
        newState.loading = false
      }

      // We are saving only 1 role
      break;
    }

    this.setState(newState);
  }

  render () {
    const categoryColumns = [];

    for (const child of this.fields) {
      const header = (
        <Cell>
          <span title={child.title || child.label}>{child.label}</span>
        </Cell>
      );

      const cell = ({ rowIndex, ...props }) => {
        const category = this.state.categories[rowIndex];

        return this._renderVisibilityField(category, child.id, rowIndex, props);
      };

      categoryColumns.push(
        <Column
          header={header}
          cell={cell}
          width={CATEGORY_WIDTH}
          key={`column-${child.id}`}
        />
      );
    }

    const modals = [];
    const columns = [];
    const visibleRoles = this.state.roleSettings.sort(
      (a, b) => a.id.toLowerCase().localeCompare(b.id.toLowerCase())
    );

    for (let i = 0; i < visibleRoles.length; ++i) {
      let roleSettings = visibleRoles[i];

      modals.push(
        <BaseModal
          key={`roleModal-${i}`}
          title={`Set Notification Settings for ${roleSettings.id}`}
          isOpen={this.state.modalsOpen[roleSettings.id]}
          onRequestClose={this.closeRoleModal.bind(this, roleSettings)}
        >
          <div className="adminModal container-fluid">
            <div className="notificationSettings row">
              <div className="col-sm-6 col-xs-12">
                <p>Set Default Hours (Per Day)</p>
                <input
                  type="number"
                  onChange={({ target }) => this.onChangeHours(i, target.value)}
                  value={roleSettings.defaultWorkingHours}
                  min="0"
                  max="24"
                  placeholder="8.0"
                />
              </div>
              <div className="col-sm-6 col-xs-12">
                <p>Set Default Notification (In Days)</p>
                <input
                  type="number"
                  onChange={({ target }) => this.onChangeDays(i, target.value)}
                  value={roleSettings.notificationDelay}
                  min="0"
                  placeholder="3"
                />
              </div>
            </div>
            <div className="row">
              <div className="saveButton col-sm-6 col-xs-12 col-sm-offset-3">
                <button
                  className="btn-submit"
                  onClick={() => { this.saveRoles() }}
                >Save</button>
              </div>
            </div>
          </div>
        </BaseModal>
      );

      columns.push(
        <Column
          key={`roleColumn-${i}`}
          fixed
          header={
            <Cell>
              <a onClick={() => this.setState({
                modalsOpen: {
                  ...this.state.modalsOpen,
                  [roleSettings.id]: true
                }
              })}>
                {(roleSettings.id === "Administrator") ? "Admin" : roleSettings.id}
              </a>
            </Cell>
          }
          cell={({ rowIndex, ...props }) => this._renderRole(
            this.state.categories[rowIndex],
            roleSettings.id,
            rowIndex,
            props
          )}
          width={COLUMN_WIDTH}
        />
      );
    }

    const categoryCount = this.state.categories.length;

    const tableWidth = LABEL_WIDTH + DESC_WIDTH + (columns.length * COLUMN_WIDTH) + (categoryColumns.length * CATEGORY_WIDTH);

    const tableHeight = 62 + (100 * categoryCount);

    return (
      <Loader show={this.state.loading} message="loading">
        <Container>
          <section className="adminContainer text-center">
            <h1>System Administration</h1>
          </section>
          <section className="adminScreen container-fluid">
            <div className="row input-header">
              <div className="col-xs-12 inputTitle">
                <Table
                  rowHeight={100}
                  rowsCount={categoryCount}
                  headerHeight={30}
                  groupHeaderHeight={30}
                  width={tableWidth}
                  height={tableHeight}
                >
                  <ColumnGroup
                    fixed
                    header={<Cell>Role</Cell>}
                  >
                    {columns}
                  </ColumnGroup>
                  <ColumnGroup
                    fixed
                    header={<Cell>Activity/Category</Cell>}
                  >
                    <Column
                      cell={({ rowIndex, ...props }) => this._renderTextField(
                        this.state.categories[rowIndex],
                        "name",
                        rowIndex,
                        "text",
                        props
                      )}
                      width={LABEL_WIDTH}
                    />
                  </ColumnGroup>
                  <ColumnGroup
                    fixed
                    header={<Cell>Description</Cell>}
                  >
                    <Column
                      cell={({ rowIndex, ...props }) => this._renderTextField(
                        this.state.categories[rowIndex],
                        "desc",
                        rowIndex,
                        "textarea",
                        props
                      )}
                      width={DESC_WIDTH}
                    />
                  </ColumnGroup>
                  <ColumnGroup
                    fixed
                    header={<Cell>Time-Tracker Field Visibility</Cell>}
                  >
                    {categoryColumns}
                  </ColumnGroup>
                </Table>
              </div>
            </div>
          </section>
          <section className="adminContainer">
            <div className="saveButton col-md-3 col-sm-4 col-xs-6">
              <button
                className="btn-save"
                onClick={() => { this.addNewCategory() }}
              >Add Activity/Category</button>
            </div>
            <div className="saveButton col-md-3 col-sm-4 col-md-offset-3 col-xs-3">
              <button
                className="btn-delete"
                onClick={() => { this.props.router.push("/") }}
              >Cancel</button>
            </div>
            <div className="saveButton col-md-3 col-sm-4 col-xs-3">
              <button
                className="btn-submit"
                onClick={() => { this.saveSettings() }}
              >Save</button>
            </div>
          </section>
          {modals}
        </Container>
      </Loader>
    );
  }
}

const DESC_WIDTH = 400;

const LABEL_WIDTH = 150;

const COLUMN_WIDTH = 50;

const CATEGORY_WIDTH = 100;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));

function normalizeRole({ id, notificationDelay, defaultWorkingHours }) {
  return {
    id,
    notificationDelay: Math.floor(notificationDelay),
    defaultWorkingHours: toFinite(defaultWorkingHours),
  };
}

function normalizeRoles(roles) {
  return _.map(roles, normalizeRole);
}

function updateRoles(roles, newRole) {
  return _.map(roles, (role) => role.id === newRole.id ? normalizeRole(newRole) : normalizeRole(role));
}



// WEBPACK FOOTER //
// ./app/components/Admin/index.jsx